module.exports = __webpack_public_path__ + "8284512629ef495b807b7c034e636dd5.MP3";